var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDpd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 26,
    viewBox: "0 0 63 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2965_15311)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0289 20.5191C39.902 20.8336 38.4344 20.9646 37.1765 20.9646C33.9008 20.9646 31.752 19.2612 31.752 16.1427C31.752 13.1814 33.7698 11.2684 36.7048 11.2684C37.36 11.2684 38.0675 11.347 38.4868 11.5566V7.25879H41.0289V20.5191ZM38.4868 13.7579C38.0937 13.5745 37.5434 13.4697 36.9145 13.4697C35.3684 13.4697 34.3463 14.4131 34.3463 16.0641C34.3463 17.8199 35.447 18.8157 37.2551 18.8157C37.5696 18.8157 38.0675 18.8157 38.4868 18.7109V13.7579ZM61.9153 20.5191C60.7884 20.8336 59.3209 20.9646 58.0368 20.9646C54.7872 20.9646 52.6121 19.2612 52.6121 16.1427C52.6121 13.1814 54.63 11.2684 57.5651 11.2684C58.2464 11.2684 58.9278 11.347 59.3471 11.5566V7.25879H61.9153V20.5191ZM59.3471 13.7579C58.954 13.5745 58.4299 13.4697 57.8009 13.4697C56.2285 13.4697 55.2065 14.4131 55.2065 16.0641C55.2065 17.8199 56.3334 18.8157 58.1416 18.8157C58.4561 18.8157 58.9278 18.8157 59.3471 18.7109V13.7579ZM45.0384 13.7579C45.4577 13.5745 46.0605 13.5221 46.5584 13.5221C48.1308 13.5221 49.2052 14.4131 49.2052 16.0117C49.2052 17.8985 47.9997 18.7633 46.4012 18.7895V20.9646H46.5322C49.8342 20.9646 51.7997 19.1564 51.7997 15.9331C51.7997 12.9979 49.7032 11.2684 46.6108 11.2684C45.0384 11.2684 43.4923 11.6352 42.4702 12.0545V24.5025H45.0384V13.7579Z",
    fill: "#3F3F42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3691 5.21484L22.7884 5.68656L23.0243 5.55553L22.3691 5.21484V5.21484Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7402 4.87402L22.5526 5.81745L22.8409 5.66021L22.5264 5.29333L21.7402 4.87402V4.87402Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0859 4.53345L22.3176 5.94859L22.6059 5.79135L21.8983 4.95275L21.0859 4.53345V4.53345Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.457 4.19263L22.0818 6.07948L22.3701 5.92225L21.2432 4.61193L20.457 4.19263ZM23.5756 7.5208L23.3921 7.62562L23.5756 7.83528V7.5208V7.5208Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8281 3.85205L21.846 6.21062L22.1343 6.05338L20.6143 4.27135L19.8281 3.85205V3.85205ZM23.4708 7.57332L23.1825 7.75676L23.5756 8.22848V7.73056L23.4708 7.57332H23.4708Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1719 3.51147L21.6091 6.34176L21.9235 6.18452L19.9843 3.93078L19.1719 3.51147V3.51147ZM23.2338 7.70446L22.9456 7.8879L23.5745 8.62168V8.12376L23.2338 7.70446Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.543 3.17065L21.3995 6.47264L21.6877 6.31541L19.3292 3.58995L18.543 3.17065V3.17065ZM22.998 7.86155L22.7097 8.01878L23.5746 9.04083V8.54291L22.998 7.86155Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9141 2.83008L21.1636 6.60378L21.4519 6.44654L18.7003 3.24938L17.9141 2.83008V2.83008ZM22.7622 7.99268L22.4739 8.14992L23.5746 9.43403V8.93611L22.7622 7.99268Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2598 2.48926L20.9286 6.73467L21.2169 6.57743L18.0721 2.90856L17.2598 2.48926V2.48926ZM22.5272 8.12357L22.2389 8.28081L23.5754 9.82698V9.32906L22.5272 8.12357V8.12357Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6309 2.14868L20.6928 6.89201L20.9811 6.70857L17.4171 2.56798L16.6309 2.14868V2.14868ZM22.2914 8.25471L22.0031 8.41195L23.5755 10.2464V9.74847L22.2914 8.25471Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9766 1.80786L20.4578 7.0229L20.7461 6.83946L16.789 2.22716L15.9766 1.80786ZM22.0826 8.3856L21.7681 8.54284L23.5763 10.6393V10.1414L22.0826 8.3856V8.3856Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3457 1.46729L20.22 7.154L20.5345 6.97059L16.1581 1.88658L15.3457 1.46729ZM21.8448 8.51673L21.5566 8.67397L23.5744 11.0587V10.5346L21.8448 8.51673V8.51673Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7168 1.12671L20.0104 7.28514L20.2987 7.10169L15.503 1.54601L14.7168 1.12671V1.12671ZM21.609 8.64787L21.3208 8.80511L23.5745 11.4519V10.954L21.609 8.64787V8.64787Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0625 0.759766L19.7754 7.41612L20.0637 7.23267L14.8749 1.20527L14.0625 0.759766ZM21.374 8.77885L21.0858 8.93608L23.5753 11.845V11.3471L21.374 8.77885V8.77885Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4336 0.418945L19.5396 7.54701L19.8279 7.38977L14.246 0.86445L13.4336 0.418945ZM21.1382 8.90974L20.85 9.06697L23.5754 12.2641V11.74L21.1382 8.90974V8.90974Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8047 0.104492L19.3038 7.67806L19.5921 7.52082L13.5908 0.523791L12.8047 0.104492ZM20.9024 9.04079L20.6141 9.19803L23.5754 12.6572V12.1593L20.9024 9.04079V9.04079Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3848 -0.000244141L19.0673 7.80918L19.3556 7.65194L12.9613 0.183199L12.8041 0.104581C12.673 0.025962 12.542 -0.000244141 12.3848 -0.000244141ZM20.6659 9.17191L20.3776 9.32915L23.5748 13.0504V12.5525L20.6659 9.17191V9.17191Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3848 -0.000244141C12.28 -0.000244141 12.1751 0.025962 12.0703 0.0521682L18.8315 7.94021L19.146 7.78297L12.4634 -0.000244141C12.4372 -0.000244141 12.411 -0.000244141 12.3848 -0.000244141ZM20.4563 9.30294L20.168 9.46018L23.5748 13.4697V12.9456L20.4563 9.30294V9.30294Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1504 0.0258789C12.098 0.0520851 12.0194 0.0782911 11.9932 0.104497L11.8359 0.183116L18.6233 8.07116L18.9116 7.91392L12.1504 0.0258789V0.0258789ZM20.2219 9.43389L19.9336 9.61733L23.5763 13.8627V13.3648L20.2219 9.43389V9.43389Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8879 0.130859L11.5996 0.288096L18.387 8.20235L18.6753 8.04511L11.8879 0.130859V0.130859ZM19.9856 9.56508L19.6973 9.74852L23.5758 14.256V13.7581L19.9856 9.56508V9.56508Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6516 0.261719L11.3633 0.418955L18.1507 8.33321L18.4389 8.17597L11.6516 0.261719V0.261719ZM19.7492 9.69594L19.461 9.87938L23.5753 14.6751V14.1772L19.7492 9.69594Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4152 0.392822L11.127 0.55006L17.9143 8.46431L18.2026 8.30707L11.4152 0.392822V0.392822ZM19.5129 9.82704L19.2246 10.0105L23.5749 15.0683V14.5704L19.5129 9.82704Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1789 0.523926L10.8906 0.681164L17.678 8.59542L17.9663 8.43818L11.1789 0.523926V0.523926ZM19.2766 9.95815L18.9883 10.1416L23.5744 15.4614V14.9635L19.2766 9.95815V9.95815Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9445 0.655029L10.6562 0.812264L17.4437 8.72652L17.7319 8.56928L10.9445 0.655029V0.655029ZM19.0684 10.0892L18.7801 10.2727L23.5759 15.8808V15.3829L19.0684 10.0892V10.0892Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7082 0.759766L10.4199 0.94321L17.2335 8.85746L17.5218 8.70023L10.7082 0.759766V0.759766ZM18.8321 10.2464L18.5438 10.4036L23.5754 16.2738V15.7759L18.8321 10.2464V10.2464Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4719 0.890869L10.1836 1.04811L16.9972 8.98857L17.2855 8.83133L10.4719 0.890869V0.890869ZM18.5958 10.3775L18.3075 10.5347L23.5749 16.6932V16.1691L18.5958 10.3775Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2355 1.02173L9.94727 1.17897L16.7609 9.14563L17.0492 8.96219L10.2355 1.02173ZM18.3594 10.5084L18.0712 10.6656L23.5745 17.0861V16.5882L18.3594 10.5084Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0012 1.15283L9.71289 1.31007L16.5265 9.27674L16.8148 9.09329L10.0012 1.15283ZM18.1251 10.6395L17.8368 10.7967L23.5759 17.4793V16.9813L18.1251 10.6395Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76483 1.28394L9.47656 1.44117L16.2902 9.40784L16.5784 9.2244L9.76483 1.28394V1.28394ZM17.8887 10.7706L17.6005 10.9278L23.5755 17.8986V17.3745L17.8887 10.7706V10.7706Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5285 1.41479L9.24023 1.57203L16.0539 9.5387L16.3421 9.35526L9.5285 1.41479ZM17.6786 10.9014L17.3904 11.0587L23.575 18.2916V17.7936L17.6786 10.9014V10.9014Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29299 1.51978L8.97852 1.67701L15.8445 9.66989L16.1328 9.48645L9.29299 1.51978V1.51978ZM17.4431 11.0326L17.1549 11.1899L23.5753 18.6848V18.1869L17.4431 11.0326V11.0326Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05666 1.65064L8.74219 1.80787L15.6344 9.82696C15.6606 9.77455 15.6868 9.74834 15.7393 9.72213L15.8965 9.61731L9.05667 1.65063L9.05666 1.65064ZM17.2068 11.1635L16.9185 11.3207L23.5225 19.0253C23.5487 18.9467 23.5749 18.8681 23.5749 18.7895V18.5798L17.2068 11.1635H17.2068Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82034 1.78174L8.50586 1.93898L15.5553 10.1415V10.0367C15.5553 9.95806 15.6077 9.85324 15.6602 9.77462L8.82034 1.78174ZM16.9705 11.2946L16.7608 11.4256C16.7346 11.4256 16.7084 11.4518 16.6822 11.4518L23.391 19.2875C23.4696 19.1826 23.522 19.0778 23.5482 18.973L16.9705 11.2946V11.2946Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58593 1.91284L8.27148 2.07008L15.5568 10.5609V10.0368L8.58593 1.91284V1.91284ZM16.2381 11.3209L23.209 19.471C23.2876 19.4186 23.3662 19.3137 23.4448 19.2351L16.7361 11.4257C16.6312 11.4781 16.474 11.4781 16.3692 11.4257L16.2381 11.3209Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3496 2.04395L8.03516 2.20118L22.9726 19.6021L23.1823 19.4972C23.2085 19.471 23.2347 19.4448 23.2609 19.4186L16.3949 11.4258H16.3687L15.766 11.0589C15.7136 11.0327 15.6873 10.9803 15.6349 10.9278C15.5825 10.8492 15.5825 10.7968 15.5563 10.7444V10.4561L8.3496 2.04395V2.04395Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1133 2.1748L7.79883 2.33204L22.7363 19.7329L23.0246 19.5757L8.1133 2.1748Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87698 2.27979L7.5625 2.43702L22.5262 19.8641L22.8145 19.7069L7.87698 2.27979Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.6426 2.41064L7.32812 2.56788L22.2918 19.995L22.5801 19.8377L7.6426 2.41064Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40627 2.54175L7.0918 2.69898L22.0555 20.1261L22.3438 19.9688L7.40627 2.54175Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14374 2.67285L6.85547 2.83009L21.8192 20.2834L22.1075 20.1L7.14374 2.67285Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90741 2.80371L6.61914 2.96095L21.5829 20.4143L21.8711 20.2308L6.90741 2.80371Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.67304 2.93481L6.38477 3.09205L21.3747 20.5454L21.663 20.3619L6.67304 2.93481Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43671 3.03955L6.14844 3.19679L21.1384 20.6763L21.4266 20.4929L6.43671 3.03955Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20038 3.17065L5.91211 3.32789L20.902 20.8074L21.1903 20.6502L6.20038 3.17065Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96405 3.30176L5.67578 3.459L12.9611 11.9498L13.1969 12.107C13.3018 12.1594 13.4066 12.2905 13.4066 12.4215V12.4477L20.6657 20.9385L20.954 20.7813L5.96405 3.30176Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72968 3.43286L5.44141 3.59009L12.2812 11.583L13.146 12.0547L5.72968 3.43286ZM13.3819 12.3429C13.3819 12.3691 13.4081 12.3954 13.4081 12.4216V12.8671L20.4313 21.0696L20.7196 20.9124L13.3819 12.3429V12.3429Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49335 3.56372L5.20508 3.72096L11.5994 11.1897L12.4642 11.6614L5.49335 3.56372V3.56372ZM13.4076 12.7621V13.26L20.2212 21.2005L20.5095 21.0433L13.4076 12.7621V12.7621Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25702 3.69482L4.96875 3.85206L10.9438 10.7967L11.7824 11.2684L5.25702 3.69482V3.69482ZM13.4071 13.1552V13.6794L19.9849 21.3316L20.2732 21.1744L13.4071 13.1552V13.1552Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02069 3.79956L4.73242 3.9568L10.2619 10.4035L11.1005 10.9014L5.02069 3.79956ZM13.4067 13.5745V14.0724L19.7486 21.4625L20.0368 21.3053L13.4067 13.5745V13.5745Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78631 3.93066L4.49805 4.0879L9.58203 10.0105L10.4206 10.5084L4.78631 3.93066V3.93066ZM13.4081 13.9676V14.4655L19.5142 21.5936L19.8024 21.4364L13.4081 13.9676V13.9676Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54999 4.06177L4.26172 4.21901L8.90019 9.64368L9.7388 10.1154L4.54999 4.06177ZM13.4077 14.3608V14.8849L19.2778 21.7509L19.5661 21.5675L13.4077 14.3608V14.3608Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31366 4.19263L4.02539 4.34987L8.21839 9.25042L9.05696 9.72213L4.31366 4.19263V4.19263ZM13.4072 14.7799V15.2778L19.0677 21.8818L19.356 21.6983L13.4072 14.7799V14.7799Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07733 4.32373L3.78906 4.48097L7.53655 8.85739L8.40133 9.32911L4.07733 4.32373V4.32373ZM13.4067 15.1731V15.671L18.8314 22.0129L19.1197 21.8294L13.4067 15.1731Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84295 4.45483L3.55469 4.61207L6.85667 8.46437L7.72148 8.96229L3.84295 4.45483V4.45483ZM10.709 12.9456L11.3903 13.7318V13.4435C11.3903 13.3911 11.3379 13.3125 11.2855 13.2863L10.709 12.9456V12.9456ZM13.4082 15.5663V16.0904L18.597 22.144L18.8853 21.9605L13.4082 15.5663V15.5663Z",
    fill: "#DB0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60663 4.55957L3.31836 4.71681L6.17483 8.07119L7.03964 8.56911L3.60663 4.55957V4.55957ZM10.0271 12.5524L11.3899 14.1248V13.6269L10.8919 13.0504L10.0271 12.5524V12.5524ZM13.4077 15.9855V16.4834L18.3607 22.2749L18.6489 22.1177L13.4077 15.9855V15.9855Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3703 4.69067L3.08203 4.84791L5.5192 7.70437L6.3578 8.17608L3.3703 4.69067V4.69067ZM9.34529 12.1856L11.3894 14.5442V14.0463L10.2101 12.6573L9.34529 12.1856ZM13.4072 16.3786V16.8765L18.1244 22.406L18.4126 22.2488L13.4072 16.3786Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13397 4.82178L2.8457 4.97902L4.83736 7.31135L5.67596 7.78306L3.13397 4.82178V4.82178ZM8.68966 11.7926L11.3889 14.9374V14.4394L9.52826 12.2643L8.68966 11.7926ZM13.4068 16.798V17.2959L17.9142 22.5371L18.2025 22.3799L13.4068 16.798V16.798Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.89959 4.95264L2.61133 5.10988L4.15749 6.91811L4.99608 7.38979L2.89959 4.95264V4.95264ZM8.00981 11.3994L11.3904 15.3303V14.8324L8.84838 11.8972L8.00981 11.3994ZM13.4083 17.1909V17.6888L17.6799 22.668L17.9681 22.5108L13.4083 17.1909V17.1909Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66327 5.08374L2.375 5.24098L3.47566 6.52509L4.31425 7.02301L2.66327 5.08374ZM7.32797 11.0063L11.3899 15.7497V15.2517L8.16658 11.5043L7.32797 11.0063ZM13.4078 17.5841V18.082L17.4436 22.7991L17.7318 22.6419L13.4078 17.5841V17.5841Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42694 5.21484L2.13867 5.37208L2.79383 6.13207L3.65863 6.62999L2.42694 5.21484V5.21484ZM6.64614 10.6395L11.3894 16.1428V15.6449L7.48474 11.1112L6.64614 10.6395ZM13.4073 18.0034V18.5014L17.2072 22.9302L17.4955 22.773L13.4073 18.0034V18.0034Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19143 5.31958L1.87695 5.47682L2.11281 5.76509L2.97761 6.2368L2.19143 5.31958ZM5.96511 10.2463L11.3898 16.562V16.0379L6.82992 10.7181L5.96511 10.2463ZM13.4076 18.3964V18.8944L16.9717 23.0873L17.26 22.9039L13.4076 18.3964Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95493 5.45068L1.77148 5.55551L2.29561 5.84378L1.95493 5.45068V5.45068ZM5.2831 9.85332L11.3891 16.9552V16.4573L6.14791 10.3512L5.2831 9.85332V9.85332ZM13.407 18.7896V19.3137L16.7614 23.2185L17.0497 23.035L13.407 18.7896V18.7896Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62891 9.46021L11.3901 17.3482V16.8503L5.4675 9.95813L4.62891 9.46021ZM13.408 19.2089V19.7068L16.5265 23.3495L16.8148 23.166L13.408 19.2089V19.2089Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94727 9.09326L11.3898 17.7675V17.2434L4.78585 9.56498L3.94727 9.09326V9.09326ZM13.4077 19.6019V20.0999L16.2904 23.4804L16.5786 23.297L13.4077 19.6019V19.6019Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26562 8.7002L11.3895 18.1606V17.6627L4.10422 9.17191L3.26562 8.7002V8.7002ZM13.4074 19.9951V20.5192L16.0542 23.6115L16.3425 23.4543L13.4074 19.9951Z",
    fill: "#DC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58398 8.30713L11.3893 18.5537V18.0558L3.42258 8.80505L2.58398 8.30713ZM13.4071 20.4144V20.9123L15.8181 23.7426L16.1064 23.5853L13.4071 20.4144V20.4144Z",
    fill: "#DB0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.90234 7.91406L11.389 18.9731V18.4752L2.74094 8.41198L1.90234 7.91406ZM13.4068 20.8075V21.3054L15.6082 23.8736L15.8964 23.7164L13.4068 20.8075V20.8075Z",
    fill: "#DA0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2207 7.54712L11.3887 19.3661V18.8682L2.08551 8.01883L1.2207 7.54712V7.54712ZM13.4066 21.2006V21.7246L15.372 24.0046L15.6603 23.8474L13.4066 21.2006Z",
    fill: "#D90032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 7.521V7.88788L11.3895 19.7593V19.2614L1.40496 7.62582L1.19531 7.521ZM13.4074 21.6199V21.9344C13.4074 21.9868 13.3812 22.0392 13.355 22.0654L15.137 24.1357L15.4253 23.9785L13.4074 21.6199V21.6199Z",
    fill: "#D80032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 7.78296V8.30709L11.3895 20.1785V19.6806L1.19531 7.78296ZM13.3812 22.0129C13.355 22.1177 13.2763 22.2226 13.1977 22.2488L13.1715 22.275L14.9011 24.2667L15.1894 24.1094L13.3812 22.0129L13.3812 22.0129Z",
    fill: "#D70032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 8.20239V8.70031L11.3895 20.5717V20.0738L1.19531 8.20239ZM13.2239 22.2227C13.2239 22.2489 13.2239 22.2489 13.1977 22.2489L12.9357 22.4061L14.6653 24.3978L14.9535 24.2406L13.2239 22.2227L13.2239 22.2227Z",
    fill: "#D60032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 8.59546V9.09338L11.3895 20.9648V20.4669L1.19531 8.59546ZM13.0143 22.3537L12.6998 22.5371L14.4556 24.555L14.7439 24.3716L13.0143 22.3537Z",
    fill: "#D50032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 9.01465V9.51257L11.3895 21.3839V20.8861L1.19531 9.01465ZM12.7785 22.4846L12.595 22.5894C12.5426 22.6156 12.4902 22.6156 12.4378 22.6156L14.2198 24.6859L14.508 24.5025L12.7785 22.4846V22.4846Z",
    fill: "#D40032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 9.40771V9.90564L11.3895 21.777V21.2791L1.19531 9.40771ZM11.9661 22.4846L13.9839 24.8169L14.2722 24.6335L12.5164 22.6156C12.4902 22.6156 12.4378 22.6418 12.4116 22.6418H12.3854C12.3067 22.6418 12.2543 22.6156 12.2019 22.5894L11.9661 22.4846L11.9661 22.4846Z",
    fill: "#D30032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 9.80078V10.3249L13.748 24.9479L14.0363 24.7645L12.1495 22.5632L11.573 22.2487C11.4681 22.1963 11.3895 22.0652 11.3895 21.9342V21.6722L1.19531 9.80078Z",
    fill: "#D20032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 10.2202V10.7181L13.5122 25.0791L13.8005 24.9219L1.19531 10.2202Z",
    fill: "#D10032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 10.6133V11.1112L13.2763 25.2101L13.5646 25.0529L1.19531 10.6133Z",
    fill: "#D00032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 11.0063V11.5305L13.0667 25.3411L13.355 25.1839L1.19531 11.0063Z",
    fill: "#CF0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 11.4255V11.9234L12.8309 25.472L13.1191 25.3148L1.19531 11.4255Z",
    fill: "#CE0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 11.8186V12.3165L12.5688 25.5769C12.6474 25.5507 12.726 25.5245 12.8047 25.4982L12.8833 25.4458L1.19531 11.8186Z",
    fill: "#CD0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 12.2119V12.736L12.2281 25.5771C12.2805 25.5771 12.3329 25.5771 12.3854 25.5771C12.464 25.5771 12.5426 25.5771 12.6212 25.5509L1.19531 12.2119Z",
    fill: "#CC0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 12.6311V13.129L11.6254 25.2887L11.9923 25.4984C12.0709 25.5508 12.2019 25.577 12.3067 25.577L1.19531 12.6311Z",
    fill: "#CB0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 13.0242V13.5221L10.944 24.8956L11.8088 25.3935L1.19531 13.0242Z",
    fill: "#CA0032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 13.4436V13.9415L10.2626 24.5026L11.1275 25.0005L1.19531 13.4436Z",
    fill: "#C90032"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 13.8367V14.3346L9.58127 24.1095L10.4199 24.6074L1.19531 13.8367Z",
    fill: "#C80033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 14.2297V14.7277L8.89991 23.7164L9.73851 24.2143L1.19531 14.2297Z",
    fill: "#C70033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 14.6489V15.1468L8.19237 23.297L9.05715 23.7949L1.19531 14.6489Z",
    fill: "#C60033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 15.042V15.5399L7.51101 22.9038L8.37578 23.4017L1.19531 15.042Z",
    fill: "#C50033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 15.4353V15.9332L6.82964 22.5109L7.69445 23.0089L1.19531 15.4353V15.4353Z",
    fill: "#C40033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 15.8545V16.3524L6.14828 22.1177L7.01309 22.6157L1.19531 15.8545Z",
    fill: "#C30033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 16.2476V16.7454L5.46691 21.7246L6.33172 22.2225L1.19531 16.2476Z",
    fill: "#C20033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 16.6406V17.1648L4.78555 21.3315L5.62415 21.8294L1.19531 16.6406Z",
    fill: "#C10033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 17.0601V17.558L4.07799 20.9386L4.94279 21.4365L1.19531 17.0601Z",
    fill: "#C00033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 17.4531V17.951L3.39663 20.5455L4.26143 21.0172L1.19531 17.4531Z",
    fill: "#BF0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 17.8462V18.3703L2.71527 20.1261L3.58007 20.6241L1.19531 17.8462Z",
    fill: "#BE0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 18.2654V18.7633L2.03391 19.7329L2.89871 20.2309L1.19531 18.2654Z",
    fill: "#BD0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19531 18.6584V18.7895C1.19531 19.0515 1.37876 19.366 1.5884 19.497L2.21735 19.8377L1.19531 18.6584V18.6584Z",
    fill: "#BC0033"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35352 19.2612C1.40593 19.3136 1.43213 19.3661 1.48455 19.3923L1.35352 19.2612Z",
    fill: "#BB0033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2965_15311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 26,
    fill: "white",
    transform: "translate(0.195312 -0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpd);
export default __webpack_public_path__ + "static/media/dpd.61b3253b548e54c43c3cea052c63a3c9.svg";
export { ForwardRef as ReactComponent };